import React from 'react';
const CloseNewsIcon = () => {
  return <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.801 0L7.11732 5.59L1.43363 0L0 1.41L5.68369 7L0 12.59L1.43363 14L7.11732 8.41L12.801 14L14.2346 12.59L8.55095 7L14.2346 1.41L12.801 0Z" fill="black"/>
  </svg>

};

export default CloseNewsIcon;